import { ENTITY_TYPE } from 'straightline-utils/constants';
import { NotAuthenticated } from 'straightline-utils/errors';

const KEY = 'straightline-token';

const validateRole = (auth) => {
  const role = auth.user.roles.some((role) => {
    return role.entity_type === ENTITY_TYPE.CARRIER;
  });

  if (!role) {
    throw new NotAuthenticated('User is not a carrier');
  }

  return auth;
};

export default (app) => {
  app.auth = null;

  app.authenticate = async (data) => {
    const setAuth = (auth, token) => {
      app.auth = auth;
      window.sessionStorage.setItem(KEY, token);
      window.localStorage.setItem(KEY, token);
      app.get('stateContainer').setInState('authenticated', true);
    };

    if (!data) {
      const token =
        window.sessionStorage.getItem(KEY) || window.localStorage.getItem(KEY);

      if (!token) {
        throw new NotAuthenticated('No token found');
      }

      const auth = await app
        .service('auth/authenticate')
        .get(token)
        .then(validateRole);

      setAuth(auth, token);

      return app.auth;
    }

    if (typeof data === 'string') {
      const auth = await app
        .service('auth/authenticate')
        .get(data)
        .then(validateRole);

      setAuth(auth, data);

      return app.auth;
    }

    const auth = await app
      .service('auth/authenticate')
      .create(data)
      .then(validateRole);

    const defaultToken = auth.tokens.find((token) => {
      return token.entity_type === ENTITY_TYPE.CARRIER;
    });

    const { token, ...payload } = defaultToken;

    setAuth({ ...auth, token, payload }, token);

    return app.auth;
  };

  app.logout = async () => {
    const token = window.localStorage.getItem(KEY);
    try {
      await app.service('auth/authenticate').remove(token);
      await app.cleanup();
    } catch (error) {}
    return { success: true };
  };

  const authHeaderHook = (context) => {
    if (!context.path.startsWith('carrier-api')) {
      return context;
    }
    const auth = context.app.auth;
    if (!auth?.token) {
      return context;
    }
    context.params.headers = {
      ...context.params.headers,
      Authorization: `Bearer ${auth.token}`
    };
    return context;
  };

  app.hooks({
    before: {
      all: [authHeaderHook]
    }
  });
};
